import { useQuery } from '@pinia/colada';
import { computed } from 'vue';

import { renterProfileService } from '@tallo/investor/renter';

import { useRenterProfileStore } from '../store/renter-profile.store';

export const getRenterScreeningQueryKey = (screeningId: string) => {
  return ['renter-screening', screeningId];
};

export function useRenterScreeningQuery() {
  const renterProfileStore = useRenterProfileStore();
  const screeningId = computed(() => renterProfileStore.getRenterProfile?.renterScreeningId as string);

  return useQuery({
    key: () => getRenterScreeningQueryKey(screeningId.value),
    enabled: () => Boolean(screeningId.value),
    query: () => renterProfileService.getRenterScreening(screeningId.value),
  });
}
